import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Download, Users } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-gradient-to-b from-slate-900 to-slate-800 text-white pt-24 pb-16 px-4" data-id="element-114">
      <div className="max-w-5xl mx-auto text-center" data-id="element-115">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-116">
          How To End Your Dog's Separation Anxiety In 15 Minutes A Day{' '}
          <span className="text-orange-400" data-id="element-117">
            Without Expensive Trainers, Shock Collars,
          </span>{' '}
          Or Feeling Guilty Every Time You Leave Your Home.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-slate-300 mb-8 max-w-3xl mx-auto" data-id="element-118">
          The{' '}
          <span className="font-semibold text-white" data-id="element-119">
            Science-Backed Calm Protocol
          </span>{' '}
          that has helped over{' '}
          <span className="font-semibold text-orange-400" data-id="element-120">
            5,000+ frustrated dog owners
          </span>{' '}
          in the USA reclaim their freedom while their dogs sleep peacefully at
          home.
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full shadow-2xl mb-12 transition-all duration-300 animate-pulse cursor-pointer" data-id="element-121">
          YES! I WANT A CALM DOG — GET INSTANT ACCESS FOR $37
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-12" data-id="element-122">
          <img src="https://cdn.magicpatterns.com/uploads/qyf85fyy6f9zFah9GnHsVU/pagina_principal.png" alt="The 15-Minute Calm Protocol - Complete Digital Bundle with 15 bonus guides" className="mx-auto max-w-md md:max-w-lg lg:max-w-xl w-full rounded-2xl drop-shadow-[0_0_40px_rgba(249,115,22,0.3)]" data-id="element-123" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-wrap justify-center gap-6 md:gap-8 text-sm md:text-base" data-id="element-124">
          <div className="flex items-center gap-2" data-id="element-125">
            <Shield className="w-5 h-5 text-green-400" data-id="element-126" />
            <span data-id="element-127">60-Day Guarantee</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-128">
            <Download className="w-5 h-5 text-green-400" data-id="element-129" />
            <span data-id="element-130">Instant Download</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-131">
            <Users className="w-5 h-5 text-green-400" data-id="element-132" />
            <span data-id="element-133">5,000+ Happy Owners</span>
          </div>
        </motion.div>
      </div>
    </section>;
}